import React from "react";
import { RefreshCw, LogOut } from "lucide-react";
import { useConfig } from "../hooks/useApi";
import { Link } from "react-router-dom";
import { ThemeToggle } from "../hooks/ThemeToggle";
import { Button } from "./ui/Button";

interface HeaderProps {
  onRefresh?: () => void;
  isRefreshing?: boolean;
  showActions?: boolean;
  onLogout?: () => void;
}

const Header: React.FC<HeaderProps> = ({
  onRefresh,
  isRefreshing = false,
  showActions = true,
  onLogout,
}) => {
  const { data: config } = useConfig();

  return (
    <header className="border-b border-border bg-background">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 lg:px-12 h-14 flex items-center justify-between gap-4">
        <Link
          to="/"
          className="flex items-center gap-2.5 min-w-0 hover:opacity-80 transition-opacity"
        >
          <img
            src="/favicon.png"
            alt=""
            aria-hidden="true"
            className="w-6 h-6 rounded shrink-0 ring-1 ring-primary/20"
          />
          <span className="text-base font-semibold tracking-tight text-foreground truncate">
            {config?.branding?.name || "Changelog"}
          </span>
        </Link>

        <div className="flex items-center gap-1">
          <ThemeToggle />
          {showActions && onRefresh && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onRefresh}
              disabled={isRefreshing}
              title="Atualizar"
              className="h-8 px-2.5"
            >
              <RefreshCw
                className={`w-3.5 h-3.5 ${isRefreshing ? "animate-spin" : ""}`}
                aria-hidden="true"
              />
              <span className="hidden sm:inline text-xs">
                {isRefreshing ? "Atualizando" : "Atualizar"}
              </span>
            </Button>
          )}
          {onLogout && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onLogout}
              title="Sair"
              className="h-8 px-2.5 text-muted-foreground hover:text-foreground"
            >
              <LogOut className="w-3.5 h-3.5" aria-hidden="true" />
              <span className="hidden sm:inline text-xs">Sair</span>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
